import { Heading, Stack, Text } from "@chakra-ui/react";

import Button from "components/Chakra/Button";

type VatiantCardProps = {
  item: {
    title: string;
    prefix: string;
    description: string;
    labels: Array<string>;
  };
  index: number;
  handleScrollToSection: () => void;
};

const VariantCard = ({
  index,
  item,
  handleScrollToSection,
}: VatiantCardProps) => (
  <Stack
    key={index}
    position="relative"
    w="330px"
    maxW="330px"
    height={{ md: index === 1 ? "464px" : "400px" }}
    borderRadius="4px"
    border={index === 1 ? "2px solid #23007d" : "none"}
    textAlign="center"
    p="32px 32px 42px"
    boxShadow="0 4px 8px rgba(161, 161, 161, 0.5)"
  >
    <Stack flex={1} align="center" spacing={0} justify="space-between">
      <Heading>{item.title}</Heading>
      <Text
        fontWeight={700}
        color="ud-grey-400"
        fontSize="21px"
        pb={{ base: "48px", md: undefined }}
      >
        {item.prefix}
      </Text>
      <Stack
        flex={1}
        spacing={0}
        justify="center"
        pb={{ base: "42px", md: undefined }}
      >
        <Text pb="14px" fontWeight={700} color="ud-black">
          {item.description}
        </Text>
        {item.labels.map((label) => (
          <Text key={Math.floor(Math.random() * 99) + 1}>{label}</Text>
        ))}
      </Stack>
      <Button
        variant={index !== 1 ? "outline" : "solid"}
        borderRadius="full"
        padding="14px 24px"
        onClick={handleScrollToSection}
      >
        Mám zájem
      </Button>
    </Stack>
    {index === 1 && (
      <Text
        color="ud-white"
        fontSize="11px"
        fontWeight={700}
        position="absolute"
        top="-22px"
        left="50%"
        transform="translateX(-50%)"
        borderRadius="full"
        backgroundColor="#23007d"
        px="24px"
      >
        NEJOBLÍBENĚJŠÍ
      </Text>
    )}
  </Stack>
);

export default VariantCard;
